import React, { Component } from 'react'
import { connect } from 'react-redux'
import Navbar from '@vmockinc/dashboard/Navbar'
import { IntlProvider } from 'react-intl'
import UnsupportedBrowser from '@vmockinc/dashboard/Pages/components/UnsupportedBrowser'
import HelpSection from '@vmockinc/dashboard/HelpSection'
import Loading from '@vmockinc/dashboard/Dashboard/components/Loading'
import { fetchUserCustomizations } from '@vmockinc/dashboard/Dashboard/actions/UserCustomizations'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'

import { getLatestFetchId, functionMappings } from '../actions/Login'
import { AspireCommunityCustomization } from '@vmockinc/dashboard/Aspire/states'
import { fetchTourStatus, startTour, getAspireIntroScreenStatus } from '../tour/Action'
import { checkForRendering } from '../actions/CustomerFeedback'
// import { fetchTranslations } from '@vmockinc/dashboard/src/languages'
import { fetchTranslations } from '../src/languages'

let customerSupportVisible = 1
let prevVisibleState = null
class App extends Component {
  UNSAFE_componentWillMount() {
    const {
      fetchUserCustomizations,
      getLatestFetchId,
      functionMappings,
      fetchTourStatus,
      getAspireIntroScreenStatus,
      pdfLanguage,
    } = this.props
    fetchUserCustomizations()
    getLatestFetchId()
    functionMappings(pdfLanguage || 'english')
    fetchTourStatus()
    getAspireIntroScreenStatus()
    AspireCommunityCustomization.fetchOnce()
  }

  // renderLoading() {
  //   return <Loading className="fullscreen" />
  // }

  componentDidMount() {
    if (document.referrer.indexOf('dashboard/aspire') >= 0) {
      sendTrackingData(
        'event',
        'dashboard_aspire_second_screen',
        'click',
        'see_detailed_feedback_btn'
      )
    }
    // Let the document know when the mouse is being used,
    // so accessibility styling can be removed.

    document.body.addEventListener('mousedown', function () {
      document.body.classList.add('using-mouse')
    })

    document.body.addEventListener('keydown', function () {
      document.body.classList.remove('using-mouse')
    })
    this.props.checkForRendering(true)
  }

  componentDidUpdate(prevProps) {
    const { pdfLanguage, functionMappings } = this.props
    if (prevProps.pdfLanguage !== pdfLanguage) {
      functionMappings(pdfLanguage || 'english')
    }
  }

  startTour() {
    sendTrackingData('event', 'aspire_appbar', 'click', 'start_tour')
    this.props.startTour()
  }

  render() {
    const {
      children,
      visible,
      startTour,
      checkForRendering,
      showButton,
      customizations,
      pdfLanguage,
    } = this.props
    
    if (prevVisibleState !== visible) {
      visible
        ? (customerSupportVisible = 0)
        : setTimeout(() => {
            customerSupportVisible = 1
            this.forceUpdate()
          }, 500)
    }
    prevVisibleState = visible
    let pathname = window.location.pathname
    const otherOptionsTranslations = {
      english: {
        'Feedback Form': 'Feedback Form',
        'Product Tour': 'Product Tour',
        'Click to open feedback form': 'Click to open feedback form',
        'Click to open product tour': 'Click to open product tour',
      },
      french: {
        'Feedback Form': 'Questionnaire de satisfaction',
        'Product Tour': 'Visite du produit',
        'Click to open feedback form': 'Cliquez pour ouvrir le formulaire de retour',
        'Click to open product tour': 'Cliquez pour commencer la visite du produit',
      },
      french_ca: {
        'Feedback Form': 'Questionnaire de satisfaction',
        'Product Tour': 'Visite du produit',
        'Click to open feedback form': 'Cliquez pour ouvrir le formulaire de retour',
        'Click to open product tour': 'Cliquez pour commencer la visite du produit',
      },
      spanish: {
        'Feedback Form': 'Formulario de comentarios',
        'Product Tour': 'Recorrido del producto',
        'Click to open feedback form': 'Haz clic para abrir el formulario de comentarios',
        'Click to open product tour': 'Haz clic para iniciar el recorrido del producto',
      },
      polish: {
        'Feedback Form': 'Formularz opinii',
        'Product Tour': 'Przewodnik po produkcie',
        'Click to open feedback form': 'Kliknij, aby otworzyć formularz opinii',
        'Click to open product tour': 'Kliknij, aby rozpocząć przewodnik po produkcie',
      },
      german: {
        'Feedback Form': 'Feedback-Formular',
        'Product Tour': 'Produkt-Tour',
        'Click to open feedback form': 'Klicken Sie hier, um das Feedback-Formular zu öffnen',
        'Click to open product tour': 'Klicken Sie hier, um die Produkt-Tour zu starten',
      },
      portuguese: {
        'Feedback Form': 'Formulário de Feedback',
        'Product Tour': 'Tour do Produto',
        'Click to open feedback form': 'Clique para abrir o formulário de feedback',
        'Click to open product tour': 'Clique para iniciar o tour do produto',
      },
      dutch: {
        'Feedback Form': 'Feedbackformulier',
        'Product Tour': 'Productrondleiding',
        'Click to open feedback form': 'Klik om het feedbackformulier te openen',
        'Click to open product tour': 'Klik om de productrondleiding te starten',
      },
      italian: {
        'Feedback Form': 'Modulo di feedback',
        'Product Tour': 'Tour del prodotto',
        'Click to open feedback form': 'Clicca per aprire il modulo di feedback',
        'Click to open product tour': 'Clicca per iniziare il tour del prodotto',
      },
    };
    const lang = (pdfLanguage || 'english').toLowerCase();
    const translations = otherOptionsTranslations[lang] || otherOptionsTranslations['english'];
    let otherOptions = [
      {
        name: translations['Feedback Form'],
        action: () => checkForRendering(),
        label: translations['Click to open feedback form'],
        tag: 'feedback',
        show: showButton,
      },
    ]

    if (!pathname.includes('summary')) {
      otherOptions.push({
        name: translations['Product Tour'],
        action: () => this.startTour(),
        label: translations['Click to open product tour'],
        tag: 'tour',
      })
    }
    let productName = 'Aspire'
    if (pdfLanguage === 'spanish') {
      productName = 'Aspira'
    } else if (['french', 'french_ca'].includes(pdfLanguage)) {
      productName = 'Aspiria'
    } else if (pdfLanguage === 'polish') {
      productName = 'Aspire'
    } else if (pdfLanguage === 'german') {
      productName = 'Aspire'
    } else if (pdfLanguage === 'portuguese') {
      productName = 'Aspire'
    }

    const intlConfig = fetchTranslations(pdfLanguage || 'english')
    
    return (
      <IntlProvider locale={intlConfig.locale} messages={intlConfig.messages}>
        <div>
          <div className="tour-body-curtain js-tour-curtain d-none" />
          <Navbar
            id="nav"
            navUrl="/dashboard/aspire"
            activeSubModule="aspire"
            productName={productName}
            moduleDisplayName="Aspire"
          />
          <div className="main-body">{children}</div>
          <UnsupportedBrowser />
          <div
            style={{ visibility: customerSupportVisible ? 'visible' : 'hidden' }}
          >
            <HelpSection path={pathname} otherOptions={otherOptions} />
          </div>
        </div>
      </IntlProvider>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user.data,
    customizations: state.userCustomizations.data,
    visible: state.InternalNavigation.visible,
    showButton: state.customerFeedback.showButton,
    pdfLanguage: state.aspireFeedbackData.pdf_language,
  }
}

export default connect(mapStateToProps, {
  fetchUserCustomizations,
  getLatestFetchId,
  functionMappings,
  fetchTourStatus,
  startTour,
  checkForRendering,
  getAspireIntroScreenStatus,
})(App)
